<template>
	<b-container fluid>
  	<div style="text-align: center;">
      <div class="logo-wrapper">
        <img class="logo-main" :src="require('@/assets/logo_blocks_rojo_azul.png')">
      </div>
    </div>
    
    <!-- Sección de Convenciones -->
    <!-- <b-card class="convenciones-card mb-3">
      <h5 class="convenciones-titulo mb-3">
        <b-icon icon="info-circle" variant="info"></b-icon>
        Convenciones
      </h5>
      <div class="convenciones-grid">
        <div class="convencion-item">
          <b-badge variant="primary" class="convencion-badge">SUB</b-badge>
          <span class="convencion-texto">Speak Up Básico</span>
        </div>
        <div class="convencion-item">
          <b-badge variant="primary" class="convencion-badge">SUA</b-badge>
          <span class="convencion-texto">Speak Up Avanzado</span>
        </div>
        <div class="convencion-item">
          <b-badge variant="primary" class="convencion-badge">IB</b-badge>
          <span class="convencion-texto">Immersion Básico</span>
        </div>
        <div class="convencion-item">
          <b-badge variant="primary" class="convencion-badge">IA</b-badge>
          <span class="convencion-texto">Immersion Avanzado</span>
        </div>
      </div>
    </b-card> -->
    
    <DashboardDisponibilidad v-if="permiso('BA0052EE')"></DashboardDisponibilidad>
    <div v-else class="welcome-wrapper">
      <div class="welcome-card">
        <div class="welcome-icon">
          <b-icon icon="star-fill"></b-icon>
        </div>
        <h3 class="welcome-titulo">¡Bienvenido a American School Way!</h3>
        <p class="welcome-texto">Nos alegra tenerte de vuelta. Selecciona una opción del menú para comenzar.</p>
      </div>
    </div>
  		<!--
      
      <DashboardAgendamientosAcumulados></DashboardAgendamientosAcumulados>
  		<DashboardAgendamientosEstudiantes></DashboardAgendamientosEstudiantes>
      <DashboardEstudiantesActivos></DashboardEstudiantesActivos>
    -->

    
	</b-container>
</template>

<script>
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
  import DashboardDisponibilidad from '@/components/Dashboard/DashboardDisponibilidad';
  import DashboardEstudiantesActivos from '@/components/Dashboard/DashboardEstudiantesActivos';
  import DashboardAgendamientosAcumulados from '@/components/Dashboard/DashboardAgendamientosAcumulados';
  import DashboardAgendamientosEstudiantes from '@/components/Dashboard/DashboardAgendamientosEstudiantes';
  import TiposConvenciones from '@/components/TiposConvenciones';
  
  export default {
    name: 'DashboardContainer',
    components:{
      DashboardDisponibilidad,
		  DashboardEstudiantesActivos,
		  DashboardAgendamientosAcumulados,
      DashboardAgendamientosEstudiantes,
      TiposConvenciones
    },
    data(){
      return {

      }
    },
    mounted () {
      
    },
    methods:{
      ...mapActions({
        
      }),
      ...mapMutations({
      }),
    },
    computed:{
      ...mapState({
        
      }),
      ...mapGetters({   
        permiso: 'auth/permiso',
      }),
    }
  }
</script>

<style scoped>

  .logo-wrapper {
    display: inline-block;
    padding: 15px 20px;
    border-radius: 12px;
    margin: 15px auto;
    position: relative;
    overflow: hidden;
  }

	.logo-main {
    width: 300px;
    margin: 0;
    text-align: center;
    display: block;
    position: relative;
    z-index: 1;
  }

  /* Mensaje de bienvenida cuando no hay contenido de disponibilidad que mostrar */
  .welcome-wrapper {
    display: flex;
    justify-content: center;
    padding: 30px 15px 60px;
  }

  .welcome-card {
    max-width: 520px;
    width: 100%;
    text-align: center;
    padding: 40px 35px;
    border-radius: 20px;
    background: linear-gradient(135deg, #0D4E8C 0%, #1976d2 60%, #063364 100%);
    color: #ffffff;
    box-shadow: 0 10px 30px rgba(13, 78, 140, 0.25);
    animation: welcome-fade-in 0.6s ease-out;
  }

  .welcome-icon {
    font-size: 2.8rem;
    margin-bottom: 15px;
    animation: welcome-float 2.5s ease-in-out infinite;
  }

  .welcome-titulo {
    font-weight: 700;
    margin-bottom: 12px;
  }

  .welcome-texto {
    margin: 0;
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 300;
  }

  @keyframes welcome-fade-in {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes welcome-float {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-8px);
    }
  }

  /* Estilos de Convenciones */
  .convenciones-card {
    max-width: 1400px;
    margin: 20px auto;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .convenciones-titulo {
    color: #495057;
    font-weight: 600;
    font-size: 1.1rem;
    margin-bottom: 1rem;
  }

  .convenciones-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 15px;
  }

  .convencion-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px;
    background-color: white;
    border-radius: 6px;
    border: 1px solid #e9ecef;
    transition: all 0.2s ease;
  }

  .convencion-item:hover {
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
  }

  .convencion-badge {
    font-size: 0.85rem;
    font-weight: 700;
    padding: 6px 12px;
    min-width: 50px;
    text-align: center;
  }

  .convencion-texto {
    font-size: 0.9rem;
    color: #495057;
    font-weight: 500;
  }

  @media (max-width: 576px) {
    .logo-wrapper {
      padding: 20px 30px;
      margin: 20px auto;
    }
    
    .logo-main {
      width: 200px;
      margin: 0;
    }

    .convenciones-grid {
      grid-template-columns: 1fr;
    }

    .convenciones-card {
      margin: 15px;
    }
  }

</style>